var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentLayout,{tag:"component",scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }